import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'
import { DISPLAY_FONT } from '../theme'
import { useServerClock } from '../hooks/useServerClock'

// Loud, per-environment colours: a non-production build must never be
// mistaken for production. Dark text on every ground for contrast.
const ENV_COLOURS: Record<string, { bg: string; fg: string }> = {
  development: { bg: '#ffd600', fg: '#1a1400' },
  beta: { bg: '#00d4ff', fg: '#00212b' },
}
const OTHER_ENV = { bg: '#ff4fa3', fg: '#2b0016' }

// A band under the header naming the deployment, centred; `thin` is an
// unlabelled 4px bar for the phone. Absent in production. The environment comes from GET /api/time, so the same bundle
// labels itself wherever it runs.
export function BuildStrip({ thin }: { thin?: boolean }) {
  const { t } = useTranslation()
  const { appEnv, synced } = useServerClock()
  if (!synced || appEnv === 'production') return null

  const { bg, fg } = ENV_COLOURS[appEnv] ?? OTHER_ENV
  const name = t(`app.envLabel.${appEnv}`, appEnv)
  if (thin) return <Box role="img" aria-label={name} title={name} sx={{ height: 4, bgcolor: bg }} />
  return (
    <Box
      sx={{
        textAlign: 'center',
        height: 22,
        lineHeight: '22px',
        fontFamily: DISPLAY_FONT,
        fontSize: '0.7rem',
        fontWeight: 800,
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
        color: fg,
        bgcolor: bg,
      }}
    >
      {name}
    </Box>
  )
}
